import React from 'react';
import {
    useGetUpdateVehiclePermitModalStep,
    useGetUpdateVehiclePermitRequestId
} from '../../../../../stores/updateVehiclePermitModal.store';

const DisplayConfirmation = () => {


    const modalStep = useGetUpdateVehiclePermitModalStep();
    const requestId = useGetUpdateVehiclePermitRequestId();

    if (modalStep !== 'confirmation') {
        return null;
    }

    const lineOneTag = 'הבקשה נקלטה בהצלחה';
    const lineTwoTag = 'מספר הבקשה הוא:';

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <div>
                <div className="fs-2">{lineOneTag}</div>
                <div className="fs-3">{lineTwoTag}<span className='mr-1 fst-italic text-decoration-underline'>{requestId}</span></div>
            </div>
        </div>
    );
}

export default DisplayConfirmation;